module.exports = __webpack_public_path__ + "static/img/bg.4b92de9d.jpg";